import {SUCCESS} from "../../../../constants/action-postfix";
import {PRIVILEGES_DETAILS_REQUEST} from "../privilegesReducer";


const initialState = []


export const privilegesDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${PRIVILEGES_DETAILS_REQUEST}${SUCCESS}`:
            return action.payload;

        default:
            return state;
    }
};
